import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import store from "./Appstore/store";
import { Provider } from "react-redux";
import Loader from "./Components/Loader";
import { Toaster } from "sonner";
import { QueryClient, QueryClientProvider } from "react-query";

export const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
      <Loader />
      <Toaster richColors position="top-center" className="MyToast" />
    </QueryClientProvider>
  </Provider>
);
